<template>
  <div class="staffDialog">
    <el-form :model="ruleForm" :hide-required-asterisk="false" label-width="90px" size="mini" label-position="right" ref="ruleForm" @submit.native.prevent :rules="rules">
      <p style="margin-bottom: 16px">基本信息</p>
      <el-form-item label="姓名：" prop="realname">
        <el-input v-model="ruleForm.realname" placeholder="请输入姓名" maxlength="20" clearable></el-input>
      </el-form-item>
      <el-form-item label="邮箱：" prop="email">
        <el-input v-model="ruleForm.email" placeholder="请输入邮箱" clearable maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="电话：" prop="phone">
        <el-input v-model="ruleForm.phone" placeholder="请输入手机号" clearable></el-input>
      </el-form-item>
      <p style="margin-bottom: 16px">工作信息</p>
      <el-form-item label="部门：" prop="depart_id">
        <el-cascader v-if="visible" :props="props" v-model="ruleForm.depart_id" clearable @change="changeValue"></el-cascader>
      </el-form-item>
      <el-form-item label="职位：" prop="job_id">
        <!-- <el-input v-model="ruleForm.job_id" placeholder="请输入岗位名称" clearable maxlength="50"></el-input> -->
        <el-select v-model="ruleForm.job_id" filterable remote clearable reserve-keyword placeholder="搜索：职位" :remote-method="remoteMethodJob" :loading="searchLevel">
          <el-option v-for="item in jobLevelList" :key="item.id" :label="item.job_name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入职时间：" prop="entry_time">
        <el-date-picker v-model="ruleForm.entry_time" value-format="yyyy-MM-dd" :clearable="false" @change="changeTime" type="date" placeholder="选择日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="工号：" prop="job_number">
        <el-input v-model="ruleForm.job_number" placeholder="请输入工号" maxlength="40" clearable></el-input>
      </el-form-item>
      <el-form-item label="用户类型：" prop="usertype">
        <el-select v-model="ruleForm.usertype" placeholder="请选择" clearable>
          <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="直接上级：" prop="leader_uid">
        <el-select v-model="ruleForm.leader_uid" filterable remote clearable reserve-keyword placeholder="搜索：姓名 / 邮箱 / 手机号 / 职称" :remote-method="remoteMethod" :loading="searchLoading">
          <el-option v-for="item in leaderList" :key="item.uid" :label="item.realname" :value="item.uid"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工作状态：" prop="working_status">
        <el-select v-model="ruleForm.working_status" placeholder="请选择">
          <el-option v-for="item in statusList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="信息状态：" prop="is_secret">
        <el-select v-model="ruleForm.is_secret" placeholder="请选择">
          <el-option v-for="(item, index) in secretList" :key="item" :label="item" :value="index"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="ruleForm.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入备注" maxlength="120" clearable></el-input>
      </el-form-item>
    </el-form>
    <div class="footer-btns">
      <div></div>
      <div>
        <el-button type="primary" size="mini" @click="submitForm" :loading="btnLoading">确 定</el-button>
        <el-button size="mini" @click="$emit('cancel')">取 消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import deparApi from "@/services/api/department/department";
import api from "@/services/api/staffManagement/staffManagement";
import { isEmail, isMobile } from "@/utils/validate";
import apiLevel from "@/services/api/jobLevel/jobLevel";
import dayjs from "dayjs";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let isEmailFun = (rule, value, callback) => {
      if (!isEmail(value)) {
        callback(new Error("邮箱格式不正确"));
      } else {
        return callback();
      }
    };
    let isMobileFun = (rule, value, callback) => {
      if (!isMobile(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        return callback();
      }
    };
    return {
      typeList: [
        { value: 0, label: "默认" },
        { value: 1, label: "普通员工" },
        { value: 2, label: "主管" },
        { value: 3, label: "经理" },
        { value: 4, label: "总监" },
        { value: 5, label: "总裁" },
        { value: 7, label: "CEO" },
        { value: 10, label: "管理员" },
      ],
      job_number_typeList: ["EH", "TY"],
      statusList: ["实习", "试用", "正式"],
      secretList: ["不保密", "保密"],
      leaderList: [],
      jobLevelList: [],
      ruleForm: {
        depart_id: "",
        realname: "",
        email: "",
        usertype: 1,
        phone: "",
        status: 1,
        job_number: "",
        job_id: "",
        leader_uid: "",
        working_status: "试用",
        is_secret: 0,
        entry_time: dayjs(new Date()).format("YYYY-MM-DD"),
        remark: "",
      },
      searchLoading: false,
      btnLoading: false,
      searchLevel: false,
      props: {
        lazy: true,
        value: "depart_id",
        label: "name",
        checkStrictly: true,
        emitPath: true,
        lazyLoad(node, resolve) {
          const { data } = node;
          deparApi.getDepartmentIndex({ pid: data ? data.depart_id : 0, level: 1 }).then((res) => {
            let tree = (dataset) => {
              dataset.map((item) => {
                if (item.children && item.children.data) {
                  item.children = item.children.data;
                } else {
                  return;
                }
                if (item.children && item.children.length > 0) {
                  tree(item.children);
                }
              });
            };
            tree(res.data);
            res.data.map((res) => {
              res.leaf = !(res.children_amount > 0);
            });
            resolve(res.data);
          });
        },
      },
      rules: {
        depart_id: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        realname: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        email: [
          { required: true, message: "此项不能为空", trigger: "blur" },
          { validator: isEmailFun, trigger: "blur" },
        ],
        // usertype: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        // phone: [{ required: true, message: '此项不能为空', trigger: 'blur' }, { validator: isMobileFun, trigger: 'blur' }],
        job_number: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        job_id: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        // leader_uid: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        // working_status: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        // is_secret: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
      },
    };
  },
  mounted() {},
  watch: {
    visible() {
      if (this.visible) {
        this.resetForm();
      }
    },
  },
  methods: {
    changeValue(e) {
      this.ruleForm.departments_id = e ? e[e.length - 1] : "";
    },
    async remoteMethod(keyword) {
      this.searchLoading = true;
      await api.getStaffIndex({ keyword }).then((res) => {
        this.leaderList = JSON.parse(JSON.stringify(res.data));
      });
      this.searchLoading = false;
    },
    async remoteMethodJob(keyword) {
      this.searchLevel = true;
      await apiLevel.getUserJobLevel({ keyword }).then((res) => {
        this.jobLevelList = JSON.parse(JSON.stringify(res.data));
      });
      this.searchLevel = false;
    },
    submitForm() {
      this.btnLoading = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.depart_id = params.depart_id[params.depart_id.length - 1];
          api
            .saveStaff(params)
            .then((res) => {
              this.$emit("complete");
              this.$message({ message: "员工新增成功", type: "success" });
              this.btnLoading = false;
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        } else {
          this.btnLoading = false;
          return false;
        }
      });
    },
    resetForm() {
      this.leaderList = [];
      this.jobLevelList = [];
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    },
    changeTime(e) {},
  },
};
</script>
<style lang="scss">
.staffDialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .el-input__inner {
    width: 100%;
  }
  .el-form-item__content {
    > div:nth-child(1) {
      width: 100%;
    }
  }
}
</style>
